import { FC, useState } from "react"
import { Container, Typography } from "@mui/material"
import { useTitle } from "@/core/hooks"
import { SnackbarAlert } from "@/core/components"
import { OperatorHelp } from "../components/help"
import { BotsTable } from "../components/tables"
import { WorkflowStepper } from "../components/stepper/workflowStepper"
import {
  ProvisionBotForm,
  ProvisionLocalError,
  ProvisionSection,
} from "../components/provision"

export const GuestBotsPage: FC = () => {
  useTitle("Гостевые боты")
  // Владение состоянием провижининга — на странице (спека §3.0).
  const [provisionOpen, setProvisionOpen] = useState(false)
  const [provisionExpanded, setProvisionExpanded] = useState(false)
  const [localProvisionErrors, setLocalProvisionErrors] = useState<
    ProvisionLocalError[]
  >([])
  const [snackbar, setSnackbar] = useState<{
    variant: "success" | "error"
    message: string
  } | null>(null)

  return (
    <Container maxWidth={false}>
      <WorkflowStepper />
      <Typography variant="h5" mb={2}>
        Гостевые боты
      </Typography>
      <OperatorHelp />
      <ProvisionSection
        expanded={provisionExpanded}
        onExpandedChange={setProvisionExpanded}
        localErrors={localProvisionErrors}
        onDismissError={(key) =>
          setLocalProvisionErrors((prev) => prev.filter((e) => e.key !== key))
        }
      />
      <BotsTable onCreateViaBotFather={() => setProvisionOpen(true)} />
      {provisionOpen && (
        <ProvisionBotForm
          onClose={() => setProvisionOpen(false)}
          onLaunched={(localErrors, launchedCount) => {
            setLocalProvisionErrors(localErrors)
            setProvisionExpanded(true)
            setProvisionOpen(false)
            if (launchedCount > 0)
              setSnackbar({
                variant: "success",
                message: `Создание запущено для ${launchedCount} ботов`,
              })
          }}
        />
      )}
      <SnackbarAlert
        isOpen={!!snackbar}
        variant={snackbar?.variant}
        message={snackbar?.message ?? ""}
        onClose={() => setSnackbar(null)}
      />
    </Container>
  )
}
